'use client';

import { Typography } from '@musinsa/mds';
import { useEffect } from 'react';
import { twMerge } from 'tailwind-merge';

interface RejectedToastProps {
  open: boolean;
  /** 기본 "캠페인이 거절되었습니다." */
  message?: string;
  /** auto-dismiss 시간 (ms) — 0 또는 undefined 시 부모가 직접 close */
  durationMs?: number;
  onDismiss: () => void;
  className?: string;
}

const DEFAULT_MESSAGE = '캠페인이 거절되었습니다.';

/**
 * 거절 완료 후 노출되는 Snackbar.
 * MDS Snackbar / Toast export 가 없으므로 Tailwind 합성 (`components-spec.md` §10.8).
 * Dim 은 시트 닫힘 후에도 부모가 유지하는 것이 권장 패턴.
 */
export const RejectedToast = ({
  open,
  message = DEFAULT_MESSAGE,
  durationMs,
  onDismiss,
  className,
}: RejectedToastProps) => {
  useEffect(() => {
    if (!open || !durationMs) return;
    const timer = setTimeout(onDismiss, durationMs);
    return () => clearTimeout(timer);
  }, [open, durationMs, onDismiss]);

  if (!open) return null;

  return (
    <div
      role="status"
      className={twMerge(
        'fixed bottom-0 left-[50%] z-[60] w-[375px] -translate-x-[50%]! px-[16px]! pb-[24px]!',
        className,
      )}
    >
      <div className="rounded-[4px] bg-[#2a2a2a] px-[12px]! py-[9px]!">
        <Typography variant="body13pxReg" colorScheme="white">
          {message}
        </Typography>
      </div>
      <div className="flex justify-center pt-[16px]!">
        <div className="h-[5px] w-[134px] rounded-[10px] bg-[#2a2a2a]" />
      </div>
    </div>
  );
};
